var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31134,
    stopColor: "#df2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#840000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,25.37358c-13.60081,0-24.62642,11.02561-24.62642,24.62642s11.02561,24.62642,24.62642,24.62642,24.62642-11.02561,24.62642-24.62642-11.02561-24.62642-24.62642-24.62642ZM50,65.05856c-8.31656,0-15.0585-6.74194-15.0585-15.05856s6.74194-15.0585,15.0585-15.0585,15.05856,6.74194,15.05856,15.0585-6.74194,15.05856-15.05856,15.05856Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.80125,47.16553l-4.46303-.89189-2.2274-3.96909c-.48671-.86713-1.73495-.86713-2.22156,0l-2.2274,3.96909-4.46303.89189c-.97511.19486-1.36087,1.38197-.68653,2.11278l3.08651,3.34487-.53099,4.52019c-.11601.98759.89387,1.72137,1.79726,1.30579l4.13492-1.90177,4.13502,1.90177c.90338.41558,1.91317-.3182,1.79716-1.30579l-.5309-4.52019,3.08651-3.34487c.67434-.73081.28858-1.91792-.68653-2.11278Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetReviewsScraper);
export default __webpack_public_path__ + "static/media/target-reviews-scraper.02de0c05b6d4fe20fe2e0d0d27fb5882.svg";
export { ForwardRef as ReactComponent };